<template>

    <app-layout title="Create User">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                <Link class="text-blue-400 hover:text-blue-600" href="/users">Users</Link> 
                <span class="text-blue-400"> /</span>
                Create
            </h2>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <jet-validation-errors class="mb-4" />

                <new-user-information-form />

            </div>
        </div>
    </app-layout>
    
</template>

<script>
    import { defineComponent } from 'vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
    import AppLayout from '@/Layouts/AppLayout.vue'
    import NewUserInformationForm from '@/Pages/Users/Partials/NewUserInformationForm.vue'

    export default defineComponent({
        components: {
            Head,
            Link,
            JetValidationErrors,
            AppLayout,
            NewUserInformationForm,
        },
    })
</script>
